module.exports = __webpack_public_path__ + "img/slavs-DE.f4b88ab2.png";